import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * P paragraph component
 * Block-level component for body text and paragraphs
 */
const P = ({ children, variant = 'body1', ...props }) => {
  return (
    <Typography variant={variant} component="p" {...props}>
      {children}
    </Typography>
  );
};

P.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['body1', 'body2']),
};

export default P;
